<template>
  <ViewCustomData entityName="facility_diagram" entitySpec="data" serviceName="BaseService"
    :columns="FACILITY_DIAGRAM_COLUMNS" :dictionary="FACILITY_DIAGRAM_DICTIONARY"
    :masterDetail="{ parent_facility_id: facilityId }" ref="viewFacilityFlange" :paginator="false" mode="edit"
    :requiredFieldsTable="{
      parent_flange_no: true,
      child_facility_id: true,
      child_flange_no: true,
    }" :prepareUpdate="prepareUpdate" :prepareInsert="prepareInsert" :beforeOpenNewRow="beforeOpenNewRow" />
</template>

<script setup>
import { ref, defineProps } from 'vue';
import { FACILITY_DIAGRAM_DICTIONARY, FACILITY_DIAGRAM_COLUMNS } from './facilityConstants';

const props = defineProps({
  facilityId: {
    type: [Number, String],
    required: true,
  },
})

// Ссылка на дочерний компонент (если нужна)
const viewFacilityFlange = ref(null);

// Реактивные данные (selected не используется в шаблоне, но оставлен для соответствия)
const selected = ref(null);

// Методы
const prepareUpdateData = (data) => {
  return {
    diagram_id: data.diagram_id,
    parent_facility_id: props.facilityId,
    parent_flange_no: data.parent_flange_no,
    child_facility_id: data.child_facility_id,
    child_flange_no: data.child_flange_no,
    flange_refresh_rate: data.flange_refresh_rate,
    flange_process_rate: data.flange_process_rate,
    date_begin: data.date_begin,
    date_end: data.date_end,
  };
}

const prepareUpdate = (rowData) => {
  return prepareUpdateData(rowData);
}

const prepareInsert = (rowData) => {
  return prepareUpdateData(rowData);
}

const beforeOpenNewRow = (rowData) => {
  rowData.diagram_id = null;
  rowData.flange_refresh_rate = 10;
  rowData.flange_process_rate = 30;
  rowData.date_begin = new Date();
}
</script>
